export default {
  PROMOTION_NAMES: {
    BAT_YAM: 'bat-yam-first-month-free',
    DISCOUNT_FIRST_MONTH_FREE: 'discount-first-month-free',
    NEVO_FIRST_MONTH_FREE: 'nevo-first-month-free',
    NEW_CREDIT_TWO_MONTHS_FREE: 'new-credit-two-months-free',
  },
  PROMOTION_TYPES: {
    ONE_TIME: 'one-time',
  },
};
